import { render, staticRenderFns } from "./saleschannel-info-modal.vue?vue&type=template&id=ffc3353a"
import script from "./saleschannel-info-modal.vue?vue&type=script&lang=js"
export * from "./saleschannel-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports